import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import TrivagoSection from './TrivagoSection';
import SalesforceSection from './SalesforceSection';
import TripadvisorSection from './TripadvisorSection';
import SojernTrackingSection from './SojernTrackingSection';
import GoogleAdsSection from './GoogleAdsSection';
import BingAdsSection from './BingAdsSection';
import HotelsNetworkSection from './HotelsNetworkSection';
import UpliftSection from './UpliftSection';
import InContextBetaSection from './InContextBetaSection';
import {
    MainPage,
    Trivago,
    Tripadvisor,
    HotelsNetwork,
    SojernTracking,
    GoogleAds,
    BingAds,
    Uplift,
    InContextBeta
} from '../../../../constants/ManageApps';
import SelectedLevel from '../common/SelectedLevel';
import {
    getThirdpartyConfiguration,
    setAppsParameters as setAppsParametersAction
} from '../../../../actions/thirdparty';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';
import { checkPermissionForLevel } from '../../../../../lib/utils';
import ThirdpartyLeaveModal from '../common/ThirdpartyLeaveModal';
import {
    SET_TEXT_VALUE_IN_CONFIG,
    TOGGLE_BOOLEAN_VALUE_IN_CONFIG,
    ADD_SALESFORCE_ALLOWED_DOMAIN
} from '../../../../constants/ActionTypes';
import If from '../../../helpers/if';
import { SAVE_LEVEL } from '../../../../constants/Level';
import { SparkExpand } from '../../../ui/spark';
import { isActive } from './utils';

class ManageApps extends Component {
    state = {
        initialSojernSelection: '',
        initialTHNSelection: ''
    };

    componentDidMount() {
        const { chainId, hotelId, selectedLevel, onPageLoad } = this.props;
        onPageLoad(chainId, hotelId, selectedLevel);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isLoading && !this.props.isLoading) {
            this.trivagoAdvertiserExpand = new SparkExpand(this.trivagoAdvertiserExpandMount);
            this.tripAdvisorExpand = new SparkExpand(this.tripAdvisorExpandMount);
            this.sojernTrackingExpand = new SparkExpand(this.sojernTrackingExpandMount);
            this.googleAdsExpand = new SparkExpand(this.googleAdsExpandMount);
            this.bingAdsExpand = new SparkExpand(this.bingAdsExpandMount);
            this.upliftExpand = new SparkExpand(this.upliftExpandMount);
            this.inContextBetaExpand = new SparkExpand(this.inContextBetaExpandMount);
            this.hotelsNetworkExpandMount = new SparkExpand(this.hotelsNetworkExpandMount);
        }

        if (
            (!get(prevProps, 'sojernTracking.status', null) && get(this.props, 'sojernTracking.status')) ||
            (this.props.isLoading && !prevProps.isLoading)
        ) {
            this.setState({ initialSojernSelection: get(this.props, 'sojernTracking.status', null) });
        }

        if (
            (!get(prevProps, 'thehotelnetwork.status', null) && get(this.props, 'thehotelnetwork.status')) ||
            (this.props.isLoading && !prevProps.isLoading)
        ) {
            this.setState({ initialTHNSelection: get(this.props, 'thehotelnetwork.status', null) });
        }
    }

    isFormInvalid = () => {
        const { trivago } = this.props;
        return trivago.advertiserIdIsInvalid;
    };

    getHeader = (title, active) => {
        return (
            <div
                className="spark-panel__header thirdPartyApp-header"
                role="heading"
                tabindex="0"
                ariaExpanded="false"
                ariaControls="expand-collapse--accordion_content"
            >
                <div className="col-md-1 status-container">
                    {active ? (
                        <span className="spark-badge spark-badge--sm spark-badge--success">
                            <i className="spark-icon-check spark-toolbar__item-helper"></i>
                            <span>Active</span>
                        </span>
                    ) : (
                        <span className="spark-badge spark-badge--sm spark-badge--notification__light spark-gray">
                            Inactive
                        </span>
                    )}
                </div>
                <div className="col-md-9">
                    <h4>{title}</h4>
                </div>
                <div className="spark-bold spark-green settings col-md-2">SETTINGS</div>
            </div>
        );
    };

    render() {
        const {
            isLoading,
            isError,
            trivago,
            parentTrivago,
            tripadvisor,
            parentTripadvisor,
            thehotelnetwork,
            parentThehotelnetwork,
            sojernTracking,
            parentSojernTracking,
            googleAds,
            parentGoogleAds,
            bingAds,
            uplift,
            parentUplift,
            parentBingAds,
            inContextBeta,
            parentInContextBeta,
            route,
            router,
            setAppsParameters,
            isDisabled,
            setConfigText,
            currentConfigCopy,
            toggleConfigBoolean,
            addSalesforceAllowedDomain,
            selectedLevel
        } = this.props;
        const { initialSojernSelection, initialTHNSelection } = this.state;
        const effectiveInContextBetaStatus =
            selectedLevel === SAVE_LEVEL.HOTEL && typeof inContextBeta === 'undefined'
                ? !!parentInContextBeta
                : !!inContextBeta;
        const canShowModal = !isError && !isLoading && !this.isFormInvalid();

        return (
            <div className="Manage">
                <main className="spark-main manageManageApps">
                    <div className="col-xl-12">
                        <div className="title spark-mar-t-1">
                            <h1>{MainPage.title}</h1>
                            <SelectedLevel />
                        </div>
                        <div className="spark-panel">
                            <div className="spark-panel__content thirdparty-section-content">
                                <h3>{MainPage.contentTitle}</h3>
                                {isLoading && (
                                    <div className="loader-wrapper">
                                        <div className="ring-loader" />
                                    </div>
                                )}
                                {isError && <p>Cannot retrieve thirdparty configuration at this time</p>}
                                <If condition={!isError && !isLoading}>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.sojernTrackingExpandMount = node)}
                                    >
                                        {this.getHeader(
                                            SojernTracking.appName,
                                            isActive(
                                                selectedLevel,
                                                get(sojernTracking, 'status'),
                                                get(parentSojernTracking, 'status')
                                            )
                                        )}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <SojernTrackingSection
                                                configurationObject={sojernTracking}
                                                chainConfigurationObject={parentSojernTracking}
                                                setValue={(key, value) => {
                                                    setAppsParameters(key, value, initialSojernSelection);
                                                }}
                                                level={selectedLevel}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.hotelsNetworkExpandMount = node)}
                                    >
                                        {this.getHeader(
                                            HotelsNetwork.appName,
                                            isActive(
                                                selectedLevel,
                                                get(thehotelnetwork, 'status'),
                                                get(parentThehotelnetwork, 'status')
                                            )
                                        )}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <HotelsNetworkSection
                                                configurationObject={thehotelnetwork}
                                                chainConfigurationObject={parentThehotelnetwork}
                                                setValue={(key, value) => {
                                                    setAppsParameters(key, value, initialTHNSelection);
                                                }}
                                                level={selectedLevel}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.tripAdvisorExpandMount = node)}
                                    >
                                        {this.getHeader(
                                            Tripadvisor.appName,
                                            isActive(
                                                selectedLevel,
                                                get(tripadvisor, 'status'),
                                                get(parentTripadvisor, 'status')
                                            )
                                        )}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <TripadvisorSection
                                                configurationObject={tripadvisor}
                                                chainConfigurationObject={parentTripadvisor}
                                                setValue={setAppsParameters}
                                                level={selectedLevel}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.trivagoAdvertiserExpandMount = node)}
                                    >
                                        {this.getHeader(
                                            Trivago.appName,
                                            isActive(
                                                selectedLevel,
                                                get(trivago, 'status'),
                                                get(parentTrivago, 'status')
                                            )
                                        )}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <TrivagoSection
                                                isDisabled={isDisabled}
                                                configurationObject={trivago}
                                                chainConfigurationObject={parentTrivago}
                                                setValue={setAppsParameters}
                                                level={selectedLevel}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.googleAdsExpandMount = node)}
                                    >
                                        {this.getHeader(
                                            GoogleAds.appName,
                                            isActive(
                                                selectedLevel,
                                                get(googleAds, 'status'),
                                                get(parentGoogleAds, 'status')
                                            )
                                        )}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <GoogleAdsSection
                                                configurationObject={googleAds}
                                                chainConfigurationObject={parentGoogleAds}
                                                setValue={setAppsParameters}
                                                level={selectedLevel}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.bingAdsExpandMount = node)}
                                    >
                                        {this.getHeader(
                                            BingAds.appName,
                                            isActive(
                                                selectedLevel,
                                                get(bingAds, 'status'),
                                                get(parentBingAds, 'status')
                                            )
                                        )}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <BingAdsSection
                                                configurationObject={bingAds}
                                                chainConfigurationObject={parentBingAds}
                                                setValue={setAppsParameters}
                                                level={selectedLevel}
                                            />
                                        </div>
                                    </div>
                                    {/* remove false If confition below and move into alphabetical placement once salesforce/barcelo feature is no longer blocked */}
                                    <If condition={false}>
                                        <div
                                            className="spark-panel spark-panel--expand"
                                            ref={node => (this.tripAdvisorExpandMount = node)}
                                        >
                                            {this.getHeader('Trip Advisor', true)}
                                            <div aria-hidden="true" className="spark-panel__content">
                                                <SalesforceSection
                                                    setConfigText={setConfigText}
                                                    currentConfigCopy={currentConfigCopy}
                                                    toggleConfigBoolean={toggleConfigBoolean}
                                                    addSalesforceAllowedDomain={addSalesforceAllowedDomain}
                                                />
                                            </div>
                                        </div>
                                    </If>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.upliftExpandMount = node)}
                                    >
                                        {this.getHeader(
                                            Uplift.appName,
                                            isActive(
                                                selectedLevel,
                                                get(uplift, 'status'),
                                                get(parentUplift, 'status')
                                            )
                                        )}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <UpliftSection
                                                configurationObject={uplift}
                                                chainConfigurationObject={parentUplift}
                                                setValue={setAppsParameters}
                                                level={selectedLevel}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="spark-panel spark-panel--expand spark-mar-b-1"
                                        ref={node => (this.inContextBetaExpandMount = node)}
                                    >
                                        {this.getHeader(InContextBeta.appName, effectiveInContextBetaStatus)}
                                        <div aria-hidden="true" className="spark-panel__content">
                                            <InContextBetaSection
                                                inContextBeta={inContextBeta}
                                                parentInContextBeta={parentInContextBeta}
                                                level={selectedLevel}
                                                isDisabled={isDisabled}
                                                setValue={(key, value) => setAppsParameters(key, value)}
                                            />
                                        </div>
                                    </div>
                                </If>
                                <ThirdpartyLeaveModal route={route} router={router} canShowModal={canShowModal} />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

ManageApps.propTypes = {
    onPageLoad: PropTypes.func.isRequired,
    setAppsParameters: PropTypes.func.isRequired,
    chainId: PropTypes.string.isRequired,
    hotelId: PropTypes.string.isRequired,
    selectedLevel: PropTypes.string.isRequired,
    thehotelnetwork: PropTypes.shape({
        apiKey: PropTypes.string,
        enabled: PropTypes.bool.isRequired
    }).isRequired,
    trivago: PropTypes.shape({
        advertiserId: PropTypes.string,
        channel: PropTypes.string.isRequired,
        enabled: PropTypes.bool.isRequired
    }).isRequired,
    inContextBeta: PropTypes.bool,
    parentInContextBeta: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    isError: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        currentConfigCopy: state.app.data.configuration.configuration.currentConfigCopy,
        hotelId: state.app.selected.selectedHotel.id,
        selectedLevel: state.app.selected.level,
        sojernTracking: get(state, 'app.data.thirdparty.data.sojernTracking', {}),
        googleAds: get(state, 'app.data.thirdparty.data.googleAds', {}),
        bingAds: get(state, 'app.data.thirdparty.data.bingAds', {}),
        thehotelnetwork: get(state, 'app.data.thirdparty.data.thehotelnetwork', {}),
        trivago: get(state, 'app.data.thirdparty.data.trivago', {}),
        tripadvisor: get(state, 'app.data.thirdparty.data.tripadvisor', {}),
        uplift: get(state, 'app.data.thirdparty.data.uplift', {}),
        inContextBeta: get(state, 'app.data.thirdparty.data.inContextBeta'),
        parentInContextBeta: get(state, 'app.data.thirdparty.parentData.inContextBeta', false),
        parentSojernTracking:
            state.app.selected.level !== SAVE_LEVEL.CHAIN
                ? get(state, 'app.data.thirdparty.parentData.sojernTracking', {})
                : null,
        parentGoogleAds:
            state.app.selected.level !== SAVE_LEVEL.CHAIN
                ? get(state, 'app.data.thirdparty.parentData.googleAds', {})
                : null,
        parentBingAds:
            state.app.selected.level !== SAVE_LEVEL.CHAIN
                ? get(state, 'app.data.thirdparty.parentData.bingAds', {})
                : null,
        parentUplift:
            state.app.selected.level !== SAVE_LEVEL.CHAIN
                ? get(state, 'app.data.thirdparty.parentData.uplift', {})
                : null,
        parentThehotelnetwork:
            state.app.selected.level !== SAVE_LEVEL.CHAIN
                ? get(state, 'app.data.thirdparty.parentData.thehotelnetwork', {})
                : null,
        parentTrivago:
            state.app.selected.level !== SAVE_LEVEL.CHAIN
                ? get(state, 'app.data.thirdparty.parentData.trivago', {})
                : null,
        parentTripadvisor:
            state.app.selected.level !== SAVE_LEVEL.CHAIN
                ? get(state, 'app.data.thirdparty.parentData.tripadvisor', {})
                : null,
        isLoading: get(state, 'app.data.thirdparty.isLoading', true),
        isError: get(state, 'app.data.thirdparty.isError', false),
        isDisabled: !checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THIRD_PARTY,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        )
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onPageLoad: (chainId, hotelId, selectedLevel) =>
            dispatch(getThirdpartyConfiguration(chainId, hotelId, selectedLevel)),
        setAppsParameters: (code, value, initialSojernSelection) =>
            dispatch(setAppsParametersAction(code, value, initialSojernSelection)),
        setConfigText: (code, value) => {
            dispatch({ type: SET_TEXT_VALUE_IN_CONFIG, code, value });
        },
        toggleConfigBoolean: (code, value) => {
            dispatch({ type: TOGGLE_BOOLEAN_VALUE_IN_CONFIG, code, value });
        },
        addSalesforceAllowedDomain: (code, value) => {
            dispatch({ type: ADD_SALESFORCE_ALLOWED_DOMAIN, code, value });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageApps));



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/index.js